import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - Fundación Carolina`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

window.onerror = function (event, source, line, col, type) {

    try {
        const data = {};

        data["log"] = "errjs";
        data["event"] = event ?? null;
        data["source"] = source ?? null;
        data["line"] = line ?? null;
        data["col"] = col ?? null;
        data["type"] = type?.toString() ?? null;

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        };

        fetch("/api/log_error", options);


    } catch (e) {
        console.log('No se ha podido registrar el error: ' + e)
    }

    return false;

}
